const styles = (theme) => {
    // styling for pieces of individual components
    return {
        bold: {
            fontWeight: 'bold',
        },
        italic: {
            fontStyle: 'italic',
        },
        divider: {
            marginTop: '.5em',
            marginBottom: '1em',
        },
        marginTop10: {
            marginTop: '10px',
        },
        marginTop20: {
            marginTop: '20px',
        },
        marginBottom10: {
            marginBottom: '10px',
        },
        width100: {
            width: '100%',
        },
        memberInformation: {
            marginTop: '20px',
            marginBottom: '20px',
            textTransform: 'capitalize',
        },
        paper: {
            padding: '16px',
            boxShadow: 0,
        },
        dividerPadding: {
            paddingTop: '16px',
            paddingBottom: '16px',
        },
        iconPadding: {
            paddingRight: '6px',
        },
        dialogProgress: {
            marginLeft: '44%',
            marginBottom: 20,
        },
        clearButton: {
            marginLeft: 10,
            marginRight: 20,
            top: '-1px',
            right: '-6px',
            float: 'right',
        },
        boldFontWeight: {
            fontWeight: 700,
        },
        priceValue: {
            color: `${theme.palette.primary.main}`,
            fontWeight: 700,
        },
        componentPadding: {
            paddingTop: '20px',
        },
        marginRight10: {
            marginRight: '10px',
        },
        height100: {
            height: '100%',
        },
        requiredText: {
            color: 'red',
            fontStyle: 'italic',
        },
        colorRed: {
            color: 'red',
        },
        AddCardIconStyle: {
            position: 'relative',
            right: '8px',
        },
        noMemberFoundText: {
            position: 'relative',
            bottom: '22px',
            fontWeight: 'bold',
        },
        linearInderminateProgress: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0px',
            left: '0px',
            right: '0px',
        },
        center: {
            display: 'flex',
            justifyContent: 'center',
        },
        paddingTop10px: {
            paddingTop: '10px !important',
        },
        outerProgressBar: {
            height: '8px',
            width: '100%',
            backgroundColor: '#E5E5E6',
            borderRadius: 5,
        },
        progressText: {
            height: '100%',
            width: '100%',
            textAlign: 'right',
            marginTop: '8px',
        },
        fullWidthContainer: {
            width: '100%',
        },
        printEstimateText: {
            position: 'relative',
            top: '-7px',
            whiteSpace: 'nowrap',
            minWidth: 'auto',
        },
        loadingButton: {
            whiteSpace: 'nowrap',
            minWidth: 'auto',
        },
        cptCode: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#333333',
        },
        serviceInput: {
            color: '#333333',
            size: '16px',
            fontWeight: 700,
        },
        serviceInputTextField: {
            '& .MuiInputLabel-root.Mui-focused': {
                color: '#6F6F6F',
                size: '14px',
                fontWeight: 700,
            },
            '.MuiInputBase-input ': {
                cursor: 'pointer',
            },
        },
        serviceInputPaper: {
            borderRadius: '32px',
            padding: '5px',
            paddingLeft: '21px',
        },
        clearSelectedServiceButton: {
            position: 'absolute',
            '&:focus': {
                outline: '#196ecf auto 1px',
            },
        },
    };
};

export const benefitStyles = {
    limitAvailable: {
        backgroundColor: '#DAFFDF',
        textColorClass: 'tds-bui-color-feedback-success-dark',
        textColorHex: '#007000',
    },
    limitReached: {
        backgroundColor: '#F9E5E5',
        textColorClass: 'tds-bui-color-feedback-danger-dark',
        textColorHex: '#C40000',
    },
};

export default styles;
